// enum State {
//   Waiting, /// 대기 (다음 상태: 모금)
//   Fundraising, /// 모금 진행 (다음 상태: 운영 or 모금 잠김 or 모금 중지 or 모금 실패)
//   FundraisingLocked, /// 모금 잠김 (다음 상태: 운영)
//   FundraisingStopped, /// 모금 중지
//   FundraisingFailed, /// 모금 실패
//   Operating, /// 운영 (다음 상태: 운영 종료 or 운영 중지)
//   OperatingClosed, /// 운영 종료
//   OperatingStopped /// 운영 중지
// }

import { POINT_SETTING_SEASON_STATUS, STAKING_POOL_STATE } from '../common/name-space';

export const StateFilter = (aData: string | number): string => {
  let re = null;
  switch (Number(aData)) {
    case STAKING_POOL_STATE.WAITING:
      re = 'Waiting';
      break;
    case STAKING_POOL_STATE.FUNDRAIS_ING:
      re = 'Fundraising';
      break;
    case STAKING_POOL_STATE.FUNDRAIS_ING_LOCKED:
      re = 'Fundraising Locked';
      break;
    case STAKING_POOL_STATE.FUNDRAIS_ING_STOPPED:
      re = 'Fundraising Stopped';
      break;
    case STAKING_POOL_STATE.FUNDRAIS_ING_FAILED:
      re = 'Fundraising Failed';
      break;
    case STAKING_POOL_STATE.OPERATING:
      re = 'Operating';
      break;
    case STAKING_POOL_STATE.OPERATING_CLOSED:
      re = 'Operating Closed';
      break;
    case STAKING_POOL_STATE.OPERATING_STOPPED:
      re = 'Operating Stopped';
      break;

    default:
      re = String(aData);
      break;
  }
  return re;
};

export const StatusSelect = [
  { value: STAKING_POOL_STATE.WAITING, label: 'Waiting' },
  { value: STAKING_POOL_STATE.FUNDRAIS_ING, label: 'Fundraising' },
  { value: STAKING_POOL_STATE.FUNDRAIS_ING_LOCKED, label: 'Fundraising Locked' },
  { value: STAKING_POOL_STATE.FUNDRAIS_ING_STOPPED, label: 'Fundraising Stopped' },
  { value: STAKING_POOL_STATE.FUNDRAIS_ING_FAILED, label: 'Fundraising Failed' },
  { value: STAKING_POOL_STATE.OPERATING, label: 'Operating' },
  { value: STAKING_POOL_STATE.OPERATING_CLOSED, label: 'Operating Closed' },
  { value: STAKING_POOL_STATE.OPERATING_STOPPED, label: 'Operating Stopped' },
];

export const StatusFilter = (aData: string | undefined): string => {
  if (!aData) {
    return '';
  }
  let re = null;
  if (aData.startsWith('stakeToken')) {
    re = 'Staked';
  } else if (aData.startsWith('claimReward')) {
    re = 'Claim Reward';
  } else if (aData.startsWith('unStakeToken')) {
    re = 'Unstaked';
  } else if (aData.startsWith('0x8448705b')) {
    re = 'withdraw';
  } else if (aData.startsWith('claimAllReward')) {
    re = 'Claim All Reward';
  } else {
    re = aData;
  }
  return re;
};

export const pointStatusFilter = (aData: number | undefined): string => {
  let re = null;
  switch (aData) {
    case POINT_SETTING_SEASON_STATUS.WAIT:
      re = '대기';
      break;
    case POINT_SETTING_SEASON_STATUS.ING:
      re = '진행중';
      break;
    case POINT_SETTING_SEASON_STATUS.END:
      re = '종료';
      break;
    default:
      re = '에러';
      break;
  }
  return re;
};

export const isHideFilter = (aData: number | undefined): string => {
  let re = null;
  switch (aData) {
    case 1:
      re = '비공개';
      break;
    case 0:
      re = '공개';
      break;
    default:
      re = 'Error';
      break;
  }
  return re;
};
